var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "property-title" }, [
    _c(
      "div",
      {
        staticClass: "property-title__input",
        class: { "property-title__input--readonly": _vm.isReadOnly }
      },
      [
        !_vm.isReadOnly
          ? _c("input", {
              attrs: {
                type: "text",
                placeholder: _vm.$t("calendar", "Event title")
              },
              domProps: { value: _vm.value },
              on: {
                input: function($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.changeValue($event)
                }
              }
            })
          : _c("div", [_vm._v(_vm._s(_vm.value))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }